





















































import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class HelpModal extends Vue {

  get controlsBelow() {
    return this.$store.state.rhizome.controlsBelow
  }

  close() {
    this.$store.dispatch('rhizome/closeHelpModal')
  }

  toggleControlsPosition() {
    this.$store.dispatch('rhizome/setControlsPosition', !this.controlsBelow)
  }
}
